import { render } from "./IntentionSetterV1Text.vue?vue&type=template&id=8332f740&scoped=true"
import script from "./IntentionSetterV1Text.vue?vue&type=script&lang=js"
export * from "./IntentionSetterV1Text.vue?vue&type=script&lang=js"

import "./IntentionSetterV1Text.vue?vue&type=style&index=0&id=8332f740&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8332f740"]])

export default __exports__